module.exports = __webpack_public_path__ + "static/AR1-985bfc5123b1d8147c5fd96b1ddf7b73.jpg";